import React from 'react';
import { find, filter } from 'lodash';
import OptionsAccordionHeader from '../../common/options/OptionsAccordionHeader';
import OptionsPage from '../../common/OptionsPage';
import {
  Accordion,
  AccordionGroup,
  AccordionContent,
} from 'core/controls/accordion/Accordion';
import { FlexViewGrid } from '../../views/flexView/FlexView';
import { TranslateHTML } from '../../../core/translate';
import OptionCards from '../../common/optionCards/OptionCards';

const PopularOptions = ({
  onChange,
  onDetails,
  mostPopularCategory,
  isUpdating,
  selectingOption,
  analyticsKey,
}) => {
  if (
    !mostPopularCategory ||
    !mostPopularCategory.options ||
    mostPopularCategory.options.length <= 0
  ) {
    return null;
  }

  return (
    <>
      <div className="option-category__label">{mostPopularCategory.label}</div>
      <FlexViewGrid className="flex-view__options-grid">
        <OptionCards
          options={mostPopularCategory.options}
          onChange={onChange}
          onDetails={onDetails}
          isUpdating={isUpdating}
          selectingOption={selectingOption}
          analyticsKey={`${analyticsKey}:most popular`}
          showMarker
        />
      </FlexViewGrid>

      <TranslateHTML
        as="div"
        className="option-category__label"
        value="all.other.options.v3"
      />
    </>
  );
};

const OtherOptions = ({
  onChange,
  onDetails,
  categories,
  isUpdating,
  selectingOption,
  showMarker,
  displayOnly,
  analyticsKey,
}) => (
  <Accordion className="accordion--options">
    {categories.map((category) => (
      <AccordionGroup
        className="accordion-item--exterior-interior-option"
        isOpenDefault={category.expanded}
        displayOnly={displayOnly}
        key={category.key}>
        <OptionsAccordionHeader
          className="accordion-title--exterior-interior-option"
          header={category.label}
          count={category.options.length}
          analyticsKey={analyticsKey}
          alignButtonLeft
        />

        <AccordionContent className="accordion-content--exterior-interior-option">
          <FlexViewGrid className="flex-view__options-grid">
            <OptionCards
              categoryKey={category.key}
              options={category.options}
              onChange={onChange}
              onDetails={onDetails}
              isUpdating={isUpdating}
              selectingOption={selectingOption}
              analyticsKey={`${analyticsKey}:${category.label}`}
              showMarker={showMarker}
            />
          </FlexViewGrid>
        </AccordionContent>
      </AccordionGroup>
    ))}
  </Accordion>
);

const Categories = ({ categories, analyticsKey }) => {
  const mostPopularCategory = find(categories, { key: 'most.popular' });
  const hasMostPopular = !!mostPopularCategory;

  const otherCategories = filter(
    categories,
    (category) =>
      category.key !== 'most.popular' && !category.dealerInstalledAccessories
  );

  const dealerInstalledAccessoriesCategories = filter(categories, {
    dealerInstalledAccessories: true,
  });

  const displayOnly = !otherCategories.find((category) => !category.expanded);

  return (
    <OptionsPage>
      {({ onChange, onDetails, isUpdating, selectingOption }) => (
        <>
          {hasMostPopular && (
            <PopularOptions
              onChange={onChange}
              onDetails={onDetails}
              mostPopularCategory={mostPopularCategory}
              isUpdating={isUpdating}
              selectingOption={selectingOption}
              analyticsKey={analyticsKey}
            />
          )}
          <div className="other-options-container">
            <OtherOptions
              onChange={onChange}
              onDetails={onDetails}
              categories={otherCategories}
              isUpdating={isUpdating}
              selectingOption={selectingOption}
              showMarker={false}
              displayOnly={displayOnly}
              analyticsKey={analyticsKey}
            />
          </div>
          {dealerInstalledAccessoriesCategories.length > 0 && (
            <>
              <TranslateHTML
                as="div"
                className="option-category__label"
                value="accessories.price.label"
              />
              <div className="other-options-container">
                <OtherOptions
                  onChange={onChange}
                  onDetails={onDetails}
                  categories={dealerInstalledAccessoriesCategories}
                  isUpdating={isUpdating}
                  selectingOption={selectingOption}
                  showMarker={false}
                  analyticsKey={analyticsKey}
                />
              </div>
            </>
          )}
        </>
      )}
    </OptionsPage>
  );
};

export default Categories;
